const Home = ({ dict }) => (
	<div className="home">
		{dict.hometext}
		<div className="home__arrow">{'<-'}</div>
	</div>
)

export default Home;
